import Cache from '@/utils/cache';
import Config from '@/utils/config';
import router from '@/router';
import API from '@/http/api';
import http from '@/http/http';

const state = {
  fullLoading: false, // 控制layout.vue里router-view loading的显示隐藏
  loadingText: '', // loading文字内容
  isCollapse: false,
  userInfo: null,
  staffId: '',
};

const mutations = {
  showFullLoading: (state) => {
    state.fullLoading = true;
  },
  closeFullLoading: (state) => {
    state.fullLoading = false;
  },
  changeLoadingText: (state, n) => {
    state.loadingText = n;
  },
  setUserInfo: (state, n) => {
    state.userInfo = n;
  },
  setCollapse: (state, n) => {
    state.isCollapse = n || false;
  },
  setStaffId: (state, n) => {
    state.staffId = n;
  },
};

const actions = {
  showFullLoading: ({ commit }, n) => {
    commit('showFullLoading');
    if (n) {
      commit('changeLoadingText', n);
    }
  },
  closeFullLoading: ({ commit }) => {
    commit('closeFullLoading');
  },
  updateUserInfo: ({ commit }, n) => {
    commit('setUserInfo', n);
  },
  updateStaffId: ({ commit }, n) => {
    commit('setStaffId', n);
  },
  loginOut: async ({ commit }) => {
    const res = await http.post(API.login_out_post, {
      requestSource: 'BACKGROUND_MANAGEMENT',
    });
    if (res?.success) {
      const remeberPhone = Cache.get(Config.REMEBER_PHONE) || false;
      const loginName = Cache.get(Config.LOGINNAME) || '';
      commit('setUserInfo', null);
      commit('setMenus', []);
      commit('setAuths', []);
      Cache.clear();
      Cache.clear(true);
      Cache.set(Config.REMEBER_PHONE, remeberPhone);
      Cache.set(Config.LOGINNAME, loginName);
      router.push('/login');
    }
  },
  loginOutNoFetch: ({ commit }) => {
    const remeberPhone = Cache.get(Config.REMEBER_PHONE) || false;
    const loginName = Cache.get(Config.LOGINNAME) || '';
    commit('setUserInfo', null);
    commit('setMenus', []);
    commit('setAuths', []);
    Cache.clear();
    Cache.clear(true);
    Cache.set(Config.REMEBER_PHONE, remeberPhone);
    Cache.set(Config.LOGINNAME, loginName);
    router.push('/login');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
